import ApiCrud from "./api-crud";

class LicenciaService extends ApiCrud {
  resource = "licencias";
  primaryKey = "idlicencia";
}

export default new LicenciaService();
